module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAASRJREFUSInl1b9Nw0AYhvHnO0VK6xHwBIENTAEKVRjB2SBMQka4bJASkSKMkA0cxAJxF4rcS5FYChD8R9ZVfOXJfn4+Sz4bpyny+0fDPWNc0WfEVoSn1L8uAewYv7s23FrGO7JZL8A0N2wkHW5Sv9pYkWeJMSwAnJEbbtdvAyEJ2BJpJz7TATb0YAlAgCWo1wZOLwXMEhh6Z9ikZ7GGsomLFa/mnwFCpVAZBRAqUchQyLogrYAqnvrVJvWrTRekETiPV2tdkFrgUrwr8idQF++CXATaxNsiv4Au8TaIbafjxtNN4jb1L2/na0U+zsxYN90b/UsetLnIodHH9OHbToPCSNXR3BeQ2fzw8z9hzfHjw0We+IBgESsuWDi0n8VABAu0n30B7E6xpZMZExYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_transaction_receive_red.png
// module id = 183
// module chunks = 1